class AgentDownloadLinkService {
  constructor(config, $http,httpDim) {
    this.config  = config;
    this.$http = $http;
    this.httpDim = httpDim;
  }

  getAgentDownloadLink() {
    let url = this.config.apiRoot + '/agentDownloadLink';
    url = this.httpDim.appendCacheBust(url);

    return this.$http.get(url,{cache: false});
  }
}

AgentDownloadLinkService.$inject = ['config', '$http','httpDim'];

export
default AgentDownloadLinkService;



// WEBPACK FOOTER //
// ./app/common/agentDownloadLinkService/agentDownloadLinkService.service.js